/**
 * Whether this bundle is running as the Teams tab entry (`teams.html` / AB#6096).
 *
 * A plain module-level flag, not a runtime check (e.g. `window.self !==
 * window.top`, which is also true for the marketing-site embed and any other
 * iframe use) — `src/teams/main.tsx` sets it synchronously before anything
 * else mounts, and it stays false for every other entry (`index.html`,
 * `embed.html`), since Vite/Rollup gives each entry its own module graph:
 * this flag is never shared across them at runtime.
 */
let runningInTeams = false

export const markRunningInTeams = (): void => {
  runningInTeams = true
}

export const isRunningInTeams = (): boolean => runningInTeams
